<script setup lang="ts">
import EventSettingsSwitch from './EventSettingsSwitch.vue'
</script>

<template>
  <EventSettingsSwitch settingName="assignPlayerOnPitch">
    <span class="w-20">Assign player on pitch</span>
  </EventSettingsSwitch>
</template>
